import React from 'react';
import useEsiPortal from '../../hooks/useEsiPortal';

interface ViewMoreProps {
  productId: string;
}

// productId is used server-side in productBody.tsx to build the ESI URL;
// the client component only provides a mount point for the relocated ESI content.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ViewMore(_props: ViewMoreProps) {
  const ref = useEsiPortal('esi-view-more');

  return <div ref={ref} />;
}

export default ViewMore;
